import { defineMessages } from "../i18n/core";

export const appMessages = defineMessages({
  "pt-BR": {
    closeMenu: "Fechar menu",
    openMenu: "Abrir menu",
    mainNav: "Navegação principal",
    customer: "Cliente",
    loadingOrg: "Carregando…",
    switchOrg: "Trocar de organização",
    allOrgs: "Ver todas as organizações",
    attention: (n: number) => `${n} exigem atenção`,
    groupProtection: "Proteção",
    groupAccount: "Conta",
    groupPlatform: "Plataforma",
    section: {
      overview: "Visão geral", machines: "Máquinas", "add-machines": "Adicionar máquinas", policies: "Políticas",
      storage: "Armazenamento", usage: "Uso e plano", activity: "Atividade", reports: "Relatórios", organizations: "Organizações", settings: "Configurações",
      "platform-storage": "Armazenamento da plataforma", help: "Ajuda",
    },
    theme: "Tema",
    themeLight: "Claro",
    themeSystem: "Seguir o sistema",
    themeSystemShort: "Sistema",
    themeDark: "Escuro",
    signOut: "Sair",
    mockFlag: "Mock · exemplo",
    mockFlagTitle: "Dados fictícios; nenhuma ação afeta máquinas reais",
    noOrgTitle: "Nenhuma organização ainda",
    noOrgBody: "Sua conta está ativa, mas ainda não tem acesso a nenhuma organização. Peça a um administrador para incluir você.",
  },
  "en-US": {
    closeMenu: "Close menu",
    openMenu: "Open menu",
    mainNav: "Main navigation",
    customer: "Customer",
    loadingOrg: "Loading…",
    switchOrg: "Switch organization",
    allOrgs: "View all organizations",
    attention: (n: number) => `${n} need attention`,
    groupProtection: "Protection",
    groupAccount: "Account",
    groupPlatform: "Platform",
    section: {
      overview: "Overview", machines: "Machines", "add-machines": "Add machines", policies: "Policies",
      storage: "Storage", usage: "Usage and plan", activity: "Activity", reports: "Reports", organizations: "Organizations", settings: "Settings",
      "platform-storage": "Platform storage", help: "Help",
    },
    theme: "Theme",
    themeLight: "Light",
    themeSystem: "Match system",
    themeSystemShort: "System",
    themeDark: "Dark",
    signOut: "Sign out",
    mockFlag: "Mock · sample",
    mockFlagTitle: "Sample data; no action affects real machines",
    noOrgTitle: "No organization yet",
    noOrgBody: "Your account is active but does not have access to any organization yet. Ask an administrator to add you.",
  },
  es: {
    closeMenu: "Cerrar menú",
    openMenu: "Abrir menú",
    mainNav: "Navegación principal",
    customer: "Cliente",
    loadingOrg: "Cargando…",
    switchOrg: "Cambiar de organización",
    allOrgs: "Ver todas las organizaciones",
    attention: (n: number) => `${n} requieren atención`,
    groupProtection: "Protección",
    groupAccount: "Cuenta",
    groupPlatform: "Plataforma",
    section: {
      overview: "Resumen", machines: "Equipos", "add-machines": "Agregar equipos", policies: "Políticas",
      storage: "Almacenamiento", usage: "Uso y plan", activity: "Actividad", reports: "Informes", organizations: "Organizaciones", settings: "Configuración",
      "platform-storage": "Almacenamiento de la plataforma", help: "Ayuda",
    },
    theme: "Tema",
    themeLight: "Claro",
    themeSystem: "Usar el del sistema",
    themeSystemShort: "Sistema",
    themeDark: "Oscuro",
    signOut: "Cerrar sesión",
    mockFlag: "Mock · ejemplo",
    mockFlagTitle: "Datos ficticios; ninguna acción afecta equipos reales",
    noOrgTitle: "Todavía no hay organizaciones",
    noOrgBody: "Tu cuenta está activa, pero todavía no tiene acceso a ninguna organización. Pide a un administrador que te agregue.",
  },
});
